export default class {
    constructor ($translate) {
        this.$translate = $translate;
    }

    getIntroduction (companyI18n) {
        if (companyI18n && companyI18n.evaluationSingleReportIntroduction) {
            return companyI18n.evaluationSingleReportIntroduction;
        }
        return this.$translate.instant('report.alias.single.introduction_text');
    }

    getResults (companyI18n) {
        if (companyI18n && companyI18n.evaluationSingleReportResults) {
            return companyI18n.evaluationSingleReportResults;
        }
        return this.$translate.instant('report.alias.single.results_text');
    }

    getStatistics (companyI18n) {
        if (companyI18n && companyI18n.evaluationSingleReportStatistics) {
            return companyI18n.evaluationSingleReportStatistics;
        }
        return this.$translate.instant('report.alias.single.statistics_text');
    }

    getSummary (companyI18n) {
        if (companyI18n && companyI18n.evaluationSingleReportSummary) {
            return companyI18n.evaluationSingleReportSummary;
        }
        return this.$translate.instant('report.alias.single.summary_text');
    }

    getScores (companyI18n) {
        if (companyI18n && companyI18n.evaluationSingleReportScores) {
            return companyI18n.evaluationSingleReportScores;
        }
        return this.$translate.instant('report.alias.single.score_introduction_text');
    }
}



// WEBPACK FOOTER //
// ./src/app/services/evaluation/report/single/index.js